//
import Vue from "vue";

// Import Axios Helper
import $axios from "@/helpers/axios-helper";

Vue.prototype.$axios = $axios;

// Import components
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);

//Import Logger

import VueLogger from "vuejs-logger";

const isProduction = process.env.NODE_ENV === "production";

const options = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};

Vue.use(VueLogger, options);

// Modal
import VModal from "vue-js-modal";
Vue.use(VModal);

import { registerVeelidateRules } from "@/validations/common";
registerVeelidateRules();

// Phone number input
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

Vue.use(VueTelInput);
